<script setup lang="ts">
import { useToast } from 'primevue/usetoast'

import { emailValidator, requiredValidator } from '~/utils/validators'

definePageMeta({
  layout: 'focus',
  middleware: 'unauthenticated',
})

const credentials = ref<{
  email: string | null
}>({
  email: null,
})

const toast = useToast()
const { $siteApi } = useNuxtApp()

const v$ = useValidation(
  () => ({
    email: { required: requiredValidator, email: emailValidator },
  }),
  credentials,
  {
    $scope: 'auth',
    $registerAs: 'forgot-password',
  }
)

const isLoading = ref(false)

const submit = async () => {
  if (!(await v$.value.$validate())) return

  try {
    await $siteApi('/forgotPassword', {
      method: 'post',
      body: credentials.value,
    })

    isLoading.value = false
    toast.add({
      severity: 'success',
      summary: 'Perfil',
      detail: `Se ha enviado a ${credentials.value.email} el correo de reestablecimiento de contraseña`,
      life: 5000,
    })
  } catch {
    isLoading.value = false
    toast.add({
      severity: 'error',
      summary: 'Autenticación',
      detail: 'Hubo un error, intentelo de nuevo más tarde, disculpe los inconvenientes.',
      life: 5000,
    })
  }
}
</script>

<template>
  <div class="flex flex-col items-center justify-center w-full lg:justify-center">
    <CardComponent class="w-full md:max-w-md">
      <template #header>
        <div class="py-4">
          <ImageComponent
            src="/img/logo-contigo.png"
            alt="Contigo"
            class="h-14"
          />
        </div>
      </template>
      <div class="flex flex-col gap-4 p-4">
        <ProcessingComponent
          v-if="isLoading"
          loading-message="Autenticando..."
        />

        <template v-else>
          <div class="flex flex-col my-4 gap-2">
            <InputField
              label="Correo Electrónico"
              :error="v$.email?.$error"
              :error-message="v$.email?.$errors[0]?.$message.toString()"
            >
              <PvInputText
                v-model.lowercase="credentials.email"
                modif
              />
            </InputField>
          </div>
          <PvButton
            :loading="isLoading"
            @click="submit"
          >
            Reestablecer contraseña
          </PvButton>
          <PvButton
            severity="contrast"
            as="a"
            href="/user/login"
          >
            Regresar
          </PvButton>
        </template>
      </div>
    </CardComponent>
  </div>
</template>
